import NumberHelper from './number-helper';
var ImageHelper = /** @class */ (function () {
    function ImageHelper() {
    }
    ImageHelper.getRatioByWindowSize = function (imageWidth, imageHeight, windowWidth, windowHeight, degree) {
        if (degree === void 0) { degree = 0; }
        var ratio = null;
        if ([90, 270].includes(Math.abs(degree))) {
            ratio = windowWidth / imageHeight;
            if (imageWidth * ratio < windowHeight) {
                ratio = windowHeight / imageWidth;
            }
            return NumberHelper.ceil(ratio, 4);
        }
        ratio = windowWidth / imageWidth;
        if (imageHeight * ratio < windowHeight) {
            ratio = windowHeight / imageHeight;
        }
        return NumberHelper.ceil(ratio, 4);
    };
    return ImageHelper;
}());
export default ImageHelper;
